/* Package JSON Import will be here */
import React, { Component } from "react";
import { Select } from "antd";
import {
  getActiveLanguage,
  getLanguages,
  setActiveLanguage
} from "react-localize-redux";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import { updateDefaultLanguage } from "reducers/localStore";
/* Project Import will be here */

class FlagSelect extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  onLangSelect(countryCode) {
    this.props.actions.setActiveLanguage(countryCode);
    this.props.actions.updateDefaultLanguage({ lang: countryCode });
  }

  handleChange(value: string) {
    this.onLangSelect(value);
    localStorage.setItem("selectedLanguageCode", value);
  };

  render() {
    const { currentLanguage, isFromLogin } = this.props;
    const { languages } = window;

    return (
      languages.length > 1 &&
      <Select
        defaultValue={currentLanguage.name}
        className={isFromLogin ? "language-select-comp-login" : "w-100"}
        onChange={(e) => this.handleChange(e)}
        options={[
          {
            value: 'en_US',
            label: 'English',
          },
          {
            value: 'es',
            label: 'Spanish',
          }
        ]}
      />
    );
  }
}

const mapStateToProps = state => ({
  currentLanguage: getActiveLanguage(state.locale),
  languages: getLanguages(state.locale)
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      updateDefaultLanguage,
      setActiveLanguage
    },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(FlagSelect);